import DeleteActivityLogsButton from "@app/components/history/desktop/DeleteActivityLogsButton.vue"
import WorkspaceActivityLogs from "@app/components/history/desktop/WorkspaceActivityLogs.vue"

export const ActivityLogsComponent = WorkspaceActivityLogs
export const ActivityLogsHeaderItem = DeleteActivityLogsButton
